var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5842 4.79222C21.3763 4.79841 21.179 4.88527 21.0341 5.03441L8.79977 17.2688L3.7654 12.2344C3.69168 12.1576 3.60339 12.0963 3.50569 12.0541C3.40798 12.0119 3.30284 11.9896 3.1964 11.9885C3.08997 11.9874 2.98439 12.0076 2.88585 12.0478C2.78731 12.088 2.69778 12.1475 2.62252 12.2228C2.54726 12.298 2.48777 12.3876 2.44754 12.4861C2.40731 12.5846 2.38714 12.6902 2.38823 12.7967C2.38931 12.9031 2.41162 13.0082 2.45384 13.1059C2.49607 13.2036 2.55737 13.2919 2.63415 13.3657L8.23415 18.9657C8.38418 19.1156 8.58764 19.1999 8.79977 19.1999C9.01191 19.1999 9.21536 19.1156 9.3654 18.9657L22.1654 6.16566C22.281 6.05329 22.36 5.90861 22.3919 5.7506C22.4239 5.59258 22.4074 5.42859 22.3445 5.28013C22.2817 5.13166 22.1755 5.00563 22.0398 4.91857C21.9041 4.83151 21.7453 4.78747 21.5842 4.79222Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.d1440ba153c6fd11011f990de2353435.svg";
export { ForwardRef as ReactComponent };